<template>
  <div class="results-component-mobile py-[16px] rounded-[10px]" v-if="searchData && searchData.length > 0">
    <div
      v-for="(searchList, i) in searchData"
      v-bind:key="i"
      class="bg-[#FFFFFF] w-full max-w-full mx-auto p-[12px] mb-[10px] rounded-[10px]"
    >
      <div v-if="searchList.type === 'account'" class="mb-[8px]">
        <h2 class="text-lg font-bold mb-3 text-blue-light">
          {{ getTotalCount(searchList) > 1 ? 'Accounts' : 'Account' }}
          &#x2022;
          {{ getTotalCount(searchList) }}
        </h2>
        <AccountsList :accounts="searchList" />
      </div>

      <div v-if="searchList.type === 'block'" class="mb-[8px]">
        <h2 class="text-lg font-bold mb-3 text-blue-light">
          {{ getTotalCount(searchList) > 1 ? 'Blocks' : 'Block' }}
          &#x2022;
          {{ getTotalCount(searchList) }}
        </h2>
        <BlocksList :blocks="searchList" />
      </div>

      <div v-if="searchList.type === 'transaction'" class="mb-[8px]">
        <h2 class="text-lg font-bold mb-3 text-blue-light">
          {{ getTotalCount(searchList) > 1 ? 'Transactions' : 'Transaction' }}
          &#x2022;
          {{ getTotalCount(searchList) }}
        </h2>
        <TransactionsList :transactions="searchList" />
      </div>

      <div v-if="searchList.type === 'token'" class="mb-[8px]">
        <h2 class="text-lg font-bold mb-3 text-blue-light">
          {{ getTotalCount(searchList) > 1 ? 'Tokens' : 'Token' }}
          &#x2022;
          {{ getTotalCount(searchList) }}
        </h2>
        <TokensList :tokens="searchList" />
      </div>

      <div v-if="searchList.type === 'nft'" class="mb-[8px]">
        <h2 class="text-lg font-bold mb-3 text-blue-light">
          {{ getTotalCount(searchList) > 1 ? 'NFTs' : 'NFT' }}
          &#x2022;
          {{ getTotalCount(searchList) }}
        </h2>
        <NFTsList :nfts="searchList" />
      </div>

      <div v-if="searchList.type === 'chain'" class="mb-[8px]">
        <h2 class="text-lg font-bold mb-3 text-blue-light">
          {{ getTotalCount(searchList) > 1 ? 'Chains' : 'Chain' }}
          &#x2022;
          {{ getTotalCount(searchList) }}
        </h2>
        <ChainsList :chains="searchList" />
      </div>

      <div v-if="searchList.type === 'meta'" class="mb-[8px]">
        <h2 class="text-lg font-bold mb-3 text-blue-light">
          {{ getTotalCount(searchList) > 1 ? 'Metadatas' : 'Metadata' }}
          &#x2022;
          {{ getTotalCount(searchList) }}
        </h2>
        <MetadataList :metadata="searchList" />
      </div>

      <div v-if="searchList.type === 'asset'" class="mb-[8px]">
        <h2 class="text-lg font-bold mb-3 text-blue-light">
          {{ getTotalCount(searchList) > 1 ? 'Assets' : 'Asset' }}
          &#x2022;
          {{ getTotalCount(searchList) }}
        </h2>
        <AssetsList :assets="searchList" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TransactionsList from '@/components/common/TransactionsList.vue';
import BlocksList from '@/components/common/BlocksList.vue';
import AccountsList from '@/components/common/AccountsList.vue';
import TokensList from '@/components/common/TokensList.vue';
import NFTsList from '@/components/common/NFTsList.vue';
import ChainsList from '@/components/common/ChainsList.vue';
import MetadataList from '@/components/common/MetadataList.vue';
import AssetsList from '@/components/common/AssetsList.vue';

export default {
  name: 'ResultsComponentMobile',
  components: {
    TransactionsList,
    BlocksList,
    AccountsList,
    TokensList,
    NFTsList,
    ChainsList,
    MetadataList,
    AssetsList,
  },
  computed: {
    ...mapGetters({
      searchData: 'getSearchData',
    }),
  },
  created() {
    if (!this.searchData || this.searchData.length === 0) {
      this.$store.dispatch('searchBlockchain', this.$route.query.value || '');
    }
  },
  methods: {
    getTotalCount(list) {
      if (!list) return 0;
      if (typeof list.total === 'number') return list.total;
      if (list.meta && typeof list.meta.count === 'number') return list.meta.count;
      return Array.isArray(list.items) ? list.items.length : 0;
    },
  },
};
</script>

<style scoped>
.results-component-mobile {
  width: 100%;
}
</style>
